import { type Qualification } from "@clipboard-health/contract-worker-app-bff";

import { TimeSlot } from "../../../Shift/Open/types";

interface GetFiltersAppliedEventPayloadParams {
  filteredOpenShiftsCount: number;
  distance: number;
  shiftTimeSlots: TimeSlot[];
  licenses: string[];
  workerQualifications?: Qualification[];
  includeWindowedOutShiftsEnabled: boolean;
  includeWindowedOutShifts: boolean;
  isFavoriteWorkplacesEnabled: boolean;
  favoriteWorkplacesOnly: boolean;
  includedStates: string[];
}

export function getFiltersAppliedEventPayload(params: GetFiltersAppliedEventPayloadParams) {
  const {
    filteredOpenShiftsCount,
    distance,
    shiftTimeSlots,
    licenses,
    workerQualifications,
    includeWindowedOutShiftsEnabled,
    includeWindowedOutShifts,
    isFavoriteWorkplacesEnabled,
    favoriteWorkplacesOnly,
    includedStates,
  } = params;

  return {
    trigger: "Filters Modal",
    shiftCount: filteredOpenShiftsCount,
    distance,
    timeSlotsAll: shiftTimeSlots.length === 0,
    timeSlots:
      shiftTimeSlots.length === 0 ? [TimeSlot.AM, TimeSlot.PM, TimeSlot.NOC] : shiftTimeSlots,
    licensesAll: licenses.length === 0,
    licenses:
      licenses.length === 0 ? workerQualifications?.map((q) => q.attributes.name) : licenses,
    ...(includeWindowedOutShiftsEnabled && {
      includeWindowedOutShifts,
    }),
    ...(isFavoriteWorkplacesEnabled && {
      favoriteWorkplacesOnly,
    }),
    includedStates,
  };
}
